import { PhraseMap } from '@ms/yammer-i18n';
import { error } from '@ms/yammer-telemetry/dist/logging';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getRebrandedStrings } from '../domains/experiments/rebranding';
import { isVivaEngageRebrandFlightEnabled } from '../domains/experiments/selectors';
import { getCurrentLocale } from '../domains/locales/selectors';
import { load as loadTranslations } from '../domains/translations/actions';
import { getTranslationDataForFeature } from '../domains/translations/selectors';
import { YammerExperimentsState, YammerI18nState } from '../state/types';

export interface StringWrapperCtor<T> {
  readonly feature: string;
  new (locale: string, phrases: PhraseMap): T;
}

export type UseTranslations = <T>(Strings: StringWrapperCtor<T>) => T;
export const useTranslations: UseTranslations = (from) => {
  const rawTranslations = useSelector((state: YammerI18nState) => getTranslationDataForFeature(state, from.feature));
  const useRebrand = useSelector((state: YammerExperimentsState) => isVivaEngageRebrandFlightEnabled(state));
  const locale = useSelector(getCurrentLocale);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await dispatch<any>(loadTranslations(from));
      } catch (err) {
        error(err);
      }
    })();
  }, [dispatch, from]);

  return useMemo(
    () => new from(locale, useRebrand ? getRebrandedStrings(rawTranslations) : rawTranslations),
    [from, locale, rawTranslations, useRebrand]
  );
};
